import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import BillingInformationForm from "../../components/BillingInformation/BillingInformationForm";
import { compose } from "../../utils/compose";
import { connect } from "react-redux";
import { billingInfoActions } from "../../store/actions/billingInformation/billingInformation";
import FullpageSpinner from "../../components/UI/FullpageSpinner/FullpageSpinner";
import { navigationActions } from "../../store/actions/navigation/navigation";
import { geoActions } from "../../store/actions/geo/geo";
import { Paper } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  mainContent: {
    flex: 1,
    padding: "46px 36px 0"
  },
  card: {
    padding: theme.spacing(3, 2)
  }
}));

const BillingInformation = props => {
  const classes = useStyles();
  const { billingInformation, onFetchBillingInfo, history, onSetTitle, onFetchCountries, countries, countriesFetching } = props;

  useEffect(() => {
    onFetchBillingInfo();
  }, [onFetchBillingInfo]);

  useEffect(() => {
    if(countries && countries.length === 0) {
      onFetchCountries();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onSetTitle('billingInformationTitle');
  }, [onSetTitle]);

  const onSubmitHandler = () => {
    history.push("/");
  }

  const onCancelHandler = () => {
    history.push("/");
  }

  return (
    <main className={classes.mainContent}>
      {billingInformation.fetching || countriesFetching ? (
        <FullpageSpinner />
      ) : (
        <Paper className={classes.card}>
          <BillingInformationForm
            current={billingInformation.data.BillingInformation}
            onSubmit={onSubmitHandler}
            onCancel={onCancelHandler}
          />
        </Paper>
      )}
    </main>
  );
};

const mapStateToProps = state => ({
  billingInformation: state.billingInformation,
  countries: state.geo.countries,
  countriesFetching: state.geo.fetching,
});

const mapDispatchToProps = dispatch => ({
  onFetchBillingInfo: () => dispatch(billingInfoActions.fetch()),
  onSetTitle: (title) => dispatch(navigationActions.setTitle(title)),
  onFetchCountries: () => dispatch(geoActions.fetchCountries())
});

var composed = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BillingInformation);

export default composed;
